<!--TimePickerDialog.vue -->
<template>
  <v-dialog v-model="displayDialog"
            width="300">
    <v-time-picker v-model="newTime"
                   :min="onlyfuture ? this.getNowTime(this.VuetifyTimeFormat) : null"
                   :max="onlypast ? this.getNowTime(this.VuetifyTimeFormat) : null"
                   color="primary"
                   format="24hr">
      <div class="d-flex justify-space-between"
           style="width:100%;">
        <v-btn @click="cancel()"
               icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn @click="newTime ? clear() : null"
               icon>
          <v-icon :color="newTime ? 'error' : ''">mdi-delete</v-icon>
        </v-btn>
        <v-btn @click="newTime ? confirm() : null"
               icon>
          <v-icon :color="newTime ? '#09ad46' : ''">mdi-check</v-icon>
        </v-btn>
      </div>
    </v-time-picker>
  </v-dialog>
</template>


<script>
export default {
  name: "TimePickerDialog",
  props: ["inTime", "externalTrigger", "onlypast", "onlyfuture"],

  data() {
    return {
      displayDialog: false,
      newTime: null,
    };
  },

  methods: {
    emitTime() {
      this.$emit("fetch", this.newTime);
    },

    cancel() {
      this.displayDialog = false;
    },

    clear() {
      this.newTime = null;
      this.emitTime();
      this.displayDialog = false;
    },

    confirm() {
      this.emitTime();
      this.displayDialog = false;
    },
  },

  watch: {
    displayDialog: function () {
      this.newTime = this.VuetifyFormatTime(this.inTime);

    },

    externalTrigger: function () {
      this.displayDialog = !this.displayDialog;
    },
  },

  computed: {},
};
</script>

<style lang="scss">
.v-time-picker-title__time .v-picker__title__btn,
.v-time-picker-title__time span {
  font-size: 70px !important;
}
</style>